import React from 'react'
import {
  Grid,
  Box,
  Container,
  Typography,
  Link,
  makeStyles,
} from '@material-ui/core'
import FaqData from 'src/component/Faqdata'

const FaqDataList = [
  {
    head: 'WHAT IS THE TOTAL SUPPLY?',
    summary:
      'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distributionYou don’t. That is the fun part. Only after the initial reveal phase is over or the sale concludes (Whichever is earlier), the artwork is assigned to your NFT. This is done by an on-chain random mechanism. The sale is purposely hidden in order to avoid the founders or anyone else to buy the rarest NFTs themselves. There is an initial sequence in which each NFT is hashed for the proof of the full collection. The actual sequence is determined after the initial sale period through a randomized starting index. So if the starting index is 5000, #0 Hashmask would get the image of the 5000th from the initial sequence. The random starting index is determined by either the first mint transaction after the reveal period or the mint transaction of the last NFT, i.e Hashmask #16383 (whichever is earlier).',
  },
  {
    head: 'WHAT IS THE TOTAL SUPPLY?',
    summary:
      'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution',
  },
  {
    head: 'WHAT IS THE TOTAL SUPPLY?',
    summary:
      'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution',
  },
  {
    head: 'WHAT IS THE TOTAL SUPPLY?',
    summary:
      'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution',
  },
  {
    head: 'WHAT IS THE TOTAL SUPPLY?',
    summary:
      'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution',
  },
]

const useStyles = makeStyles((theme) => ({
  FAQ: {
    background: '#092642',
    backgroundImage: 'url(./images/gameground.png)',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    padding: '100px 0 140px',
    backgroundAttachment: 'fixed',
    [theme.breakpoints.down('sm')]: {
      padding: '50px 0px 50px',
    },
    [theme.breakpoints.down('xs')]: {
      padding: '20px 0px 50',
    },
  },
  extraHeader: {
    '& h2': {
      color: '#fff',
      [theme.breakpoints.down('xs')]: {
        lineHeight: '45px',
      },
    },
  },
  mobilexs: {
    padding: '40px 0px 16px 0px',
    [theme.breakpoints.down('xs')]: {
      padding: '15px 0px 10px 0px',
    },
    '& h2': {
      fontSize: '70px',
      fontWeight: '400',
      color: '#fff',
      marginTop: '20px',
      marginBottom: '30px',
      [theme.breakpoints.down('sm')]: {
        lineHeight: '50px',
        fontSize: '50px',
      },
      [theme.breakpoints.down('xs')]: {
        lineHeight: '30px',
        fontSize: '30px',
        marginTop: '0px',
        marginBottom: '30px',
      },
    },
  },

  head: {
    // marginTop: '-107px',
    // position: 'relative',
    // zIndex: '1',
  },
  botomleft: {
    position: 'absolute',
    bottom: '-99px',
    left: '0px',
    width: '100%',
    maxWidth: '600px',
    [theme.breakpoints.down('md')]: {
      bottom: '-17px',
      width: '25%',
    },
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  botomright: {
    position: 'absolute',
    bottom: '-99px',
    right: '0px',
    width: '100%',
    maxWidth: '600px',
    [theme.breakpoints.down('md')]: {
      bottom: '-17px',
      width: '25%',
    },
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
}))

export default function Dashboard() {
  const classes = useStyles()
  return (
    <>
      <Box className={classes.FAQ}>
        <Box className={classes.head}></Box>
        <Box className={classes.mobilexs}>
          <Container maxWidth="md">
            <Box textAlign="center">
              <Box pb={5}>
                <Typography variant="h2">FAQs</Typography>
              </Box>
            </Box>
            <Grid container spacing={1}>
              {FaqDataList.map((data, i) => {
                return (
                  <Grid item xs={12} sm={12} md={12} key={i}>
                    <FaqData data={data} index={i} />
                  </Grid>
                )
              })}
            </Grid>
          </Container>
        </Box>
        <img
          src="images/topleftarrow.png"
          alt="Top Left Arrow"
          className={classes.botomleft}
        />
        <img
          src="images/toprightarrow.png"
          alt="Top Right Arrow"
          className={classes.botomright}
        />
      </Box>
    </>
  )
}
